/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  FAQ_TOPIC,
  FAQ_TOPICS,
  FAQ_TOPIC_QUESTION,
  FAQ_TOPIC_QUESTIONS,
} from '~/actions/actionTypes';

const initialState: reducers.FaqReducer = {
  faqTopics: null,
  faqTopicQuestions: null,
  faqTopic: null,
  faqTopicQuestion: null,
  contact: null,
};

const faqReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FAQ_TOPICS:
      state = {
        ...state,
        faqTopics: action.payload.faqTopics,
        contact: action.payload.contact,
      };
      break;

    case FAQ_TOPIC_QUESTIONS:
      state = {
        ...state,
        faqTopicQuestions: action.payload,
      };
      break;

    case FAQ_TOPIC:
      state = {
        ...state,
        faqTopic: action.payload,
      };
      break;

    case FAQ_TOPIC_QUESTION:
      state = {
        ...state,
        faqTopicQuestion: action.payload,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default faqReducer;
